import { render, staticRenderFns } from "./SCollapse.vue?vue&type=template&id=1b3828fe&scoped=true&"
import script from "./SCollapse.vue?vue&type=script&lang=js&"
export * from "./SCollapse.vue?vue&type=script&lang=js&"
import style0 from "./SCollapse.vue?vue&type=style&index=0&id=1b3828fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3828fe",
  null
  
)

export default component.exports